import React from "react";
import ExperienceCard from "./ExperienceCard";
import { Timeline, TimelineEvent } from "react-event-timeline";
import JobIcon from "../Assets/Images/JobIcon";
import Experiencedata from "../Data/Experiencedata";
const Experience = () => {
  return (
    <>
      <Timeline
        style={{
          width: "100%",
          padding: 0,
        }}
      >
        {Experiencedata.map((item) => (
          <TimelineEvent
            iconColor="#4763e0"
            orientation="1px"
            key={`${item.company}-${item.position}`}
            className="experience-card "
            style={{
              boxShadow: "none",
              border: 0,
              padding: 0,
            }}
            createdAt={
              <h3>
                <span className="title-primary">{item.position}</span> ·{" "}
                {item.company}
              </h3>
            }
            title={
              <span className="text-gray">
                {item.dateduration} · {item.monthduration}
              </span>
            }
            icon={<JobIcon />}
            collapsible
            showContent
          >
            <ExperienceCard data={item} />
          </TimelineEvent>
        ))}
      </Timeline>
    </>
  );
};

export default Experience;
